export interface ConvexProfile {
  name: string;
  email: string;
  id: string;
}

// Self-hosted: profile comes from local auth, not cloud API
export async function getConvexProfile(_convexAuthToken: string): Promise<ConvexProfile> {
  return { name: '', email: '', id: '' };
}
